// Components/MessagesArea/MessagesArea.jsx
import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import LoginContainer from './components/LoginContainer';
import MessagesContainer from './components/MessagesContainer';
import { useMessageManager } from './hooks/useMessageManager';
import { useScrollManager } from './hooks/useScrollManager';

const MessagesArea = ({
    messagesUser,
    isLoadingMessage,
    isLoadingCurrentMode,
    userLoggedIn,
    isMobile,
    setUserSystem,
    isMessagesReady,
    setIsMessagesReady,
    contactActive
}) => {
    // Referencias
    const messagesContainerRef = useRef(null);
    const endOfMessagesRef = useRef(null);
    const initialScrollDoneRef = useRef(false);
    
    // Hook para gestionar mensajes
    const {
        allMessages,
        hasMore,
        isLoadingMore,
        loadMoreMessages
    } = useMessageManager({
        messagesUser,
        messagesContainerRef,
        contactActive,
        setIsMessagesReady,
        isMessagesReady
    });
    
    // Hook para gestionar el scroll
    const { handleScroll } = useScrollManager({
        messagesContainerRef,
        hasMore,
        isLoadingMore,
        loadMoreMessages
    });
    
    // Efecto para hacer scroll al último mensaje cuando se cargan los mensajes inicialmente
    useEffect(() => {
        // console.log('🔄 MessagesArea - Cambio en mensajes o isMessagesReady', {
        //     mensajesCount: allMessages.length,
        //     isReady: isMessagesReady,
        //     contactId: contactActive?.idContact
        // });
       
        if (allMessages.length > 0 && isMessagesReady && endOfMessagesRef.current && !initialScrollDoneRef.current) {
            // console.log('🔍 Intentando hacer scroll a último mensaje');
            setTimeout(() => {
                try {
                    endOfMessagesRef.current.scrollIntoView({ behavior: 'auto' });
                    initialScrollDoneRef.current = true;
                    // console.log('✅ Scroll completado');
                } catch (error) {
                    // console.error("Error al hacer scroll:", error);
                }
            }, 150);
        }
    }, [allMessages, isMessagesReady, contactActive?.idContact]);
    
    // Resetear el estado de scroll al cambiar de contacto
    useEffect(() => {
        if (contactActive) {
            initialScrollDoneRef.current = false;
        }
    }, [contactActive?.idContact]);
    
    // Mostrar login si el usuario no está autenticado
    if (!userLoggedIn) {
        return (
            <LoginContainer
                isMobile={isMobile}
                setUserSystem={setUserSystem}
            />
        );
    }
    
    return (
        <Box
            ref={messagesContainerRef}
            sx={{
                flex: 1,
                overflowY: 'auto',
                padding: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
            onScroll={handleScroll}
        >
            <MessagesContainer
                isLoadingMessage={isLoadingMessage}
                isLoadingCurrentMode={isLoadingCurrentMode}
                isLoadingMore={isLoadingMore}
                hasMore={hasMore}
                allMessages={allMessages}
                contactActive={contactActive}
                endOfMessagesRef={endOfMessagesRef}
            />
        </Box>
    );
};

export default MessagesArea;